import _calculateResponsiveState from './calculateResponsiveState';
export { _calculateResponsiveState as calculateResponsiveState };